import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";

type StatusIndicatorIconProps = Partial<SVGIconProps>;
const StatusIndicatorIcon = (props: StatusIndicatorIconProps) => {
  return (
    <SVGIcon viewBox="0 0 10 10" {...props}>
      <circle cx="3" cy="3.60156" fill={props?.fill ?? "currentColor"} r="3" />
    </SVGIcon>
  );
};

export default StatusIndicatorIcon;
